import type { RecaptchaMethods } from './types.tsx';

type WindowWithRecaptcha = typeof window & {
	grecaptcha: RecaptchaMethods;
};

export const getRecaptchaMethods = (): RecaptchaMethods =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	(window as WindowWithRecaptcha).grecaptcha.enterprise;

export const isAnyRecaptchaScriptPresent = (regex: RegExp): boolean =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	Array.from(document.scripts).some((script) => regex.test(script.src));

export const injectScript = (scriptSrc: string, regexPattern: RegExp): Promise<boolean> =>
	new Promise(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(resolve: (result: Promise<boolean> | boolean) => void, reject: (error?: any) => void) => {
			// if script is already added in html donot add again
			if (isAnyRecaptchaScriptPresent(regexPattern)) {
				resolve(false);
				return;
			}
			// eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
			const script = document.createElement('script');

			script.async = true;
			script.defer = true;
			script.src = scriptSrc;
			script.addEventListener('load', () => {
				getRecaptchaMethods().ready(() => {
					resolve(true);
				});
			});
			// @ts-expect-error - TS2769 - No overload matches this call.
			script.addEventListener('error', (error: ProgressEvent) => {
				reject(error);
			});

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			if (document.head) {
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				document.head.appendChild(script);
			}
		},
	);
